export class DtoPais {
    Codigo: string = '';
    Nombre: string = '';
}